//
//
//
//
//
//
export default {
  props: {
    button: {
      type: Object
    },
    toolbarName: {
      type: String
    },
    userSettings: {
      type: Object
    },
    pageAttributes: {
      type: Object
    },
    recaptchaPublicKey: {
      type: String
    }
  },
  methods: {
    onClick: function onClick(event) {
      event.stopPropagation();
      this.performAction(event);
    },
    $_getAnalyticsPosition: function $_getAnalyticsPosition() {
      return this.toolbarName + (this.button ? '.' + this.button.namePassedToEvents : '');
    },
    $_raiseAnalyticsEvent: function $_raiseAnalyticsEvent(eventType, addParams) {
      var eventParams = Object.assign({}, addParams);
      eventParams.EventType = eventType;
      eventParams.Position = eventParams.Position || this.$_getAnalyticsPosition();
      GeneralMills.Analytics && GeneralMills.Analytics.raiseEvent(eventParams);
    },
    $_privacyOptOutModal: function $_privacyOptOutModal(button) {
      if (button.showPrivacyOptOutMessage != true) {
        return false;
      }

      var headerText = button.displayName; // Use the 'button' parameter here

      var modalClass = "actionToolbarGenericModal" + button.displayName; // Use the 'button' parameter here

      var settings = {
        headerText: headerText,
        contentValue: button.privacyOptOutMessage,
        // Use the 'button' parameter here
        modalClass: modalClass
      };
      this.$emit('set-modal', 'genericModal', settings);
      return true;
    },
    $_checkForprivacyOptOut: function $_checkForprivacyOptOut(button) {
      if (button.showPrivacyOptOutMessage == true) {
        // Use the 'button' parameter here
        this.$_privacyOptOutModal(button); // Use the 'button' parameter here

        return true;
      } else {
        return false;
      }
    }
  }
};